import css from '@holmescorp/book-widgets/css/topicpage.m.css';

export const knownClasses = new Set(Object.keys(css));
